export interface DeepLinkParts {
	pathname: string;
	search: URLSearchParams;
}

const stripTrailingSlash = (pathname: string): string =>
	pathname.length > 1 && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;

const splitDeepLink = (deepLink: string): DeepLinkParts => {
	const withoutHash = deepLink.trim().split("#")[0];
	const queryIndex = withoutHash.indexOf("?");
	const pathname = stripTrailingSlash(queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex));
	const search = new URLSearchParams(queryIndex === -1 ? "" : withoutHash.slice(queryIndex + 1));
	return { pathname, search };
};

export default splitDeepLink;
